
import AddPlayers from "@/components/americano/AddPlayers.vue";
import ShowGames from "@/components/americano/ShowGames.vue";
import ShowScore from "@/components/americano/ShowScore.vue";
import { defineComponent } from "vue";
import store from "@/store/index";

export default defineComponent({
    components: {
        AddPlayers,
        ShowGames,
        ShowScore,
    },
    computed: {
        getStep(): number {
            return store.getters.americanoStore.getStep;
        },
    },
});
